import * as React from 'react';
function ArrowChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": props['data-testid']
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.207 8.293a1 1 0 010 1.414L12 15.914 5.793 9.707a1 1 0 011.414-1.414L12 13.086l4.793-4.793a1 1 0 011.414 0z",
    fill: "currentColor"
  }));
}
export default ArrowChevronDown;